import { render, staticRenderFns } from "./MarkdownWrapper.vue?vue&type=template&id=57743261&scoped=true&"
import script from "./MarkdownWrapper.vue?vue&type=script&lang=js&"
export * from "./MarkdownWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownWrapper.vue?vue&type=style&index=0&id=57743261&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57743261",
  null
  
)

export default component.exports